<template>
  <div class="" id="calOrder" v-loading="orderLoading">
    <ZnBreadcrumb />
    <div class="main-content">
      <div class="goods-info">
        <div class="table-title">
          <span>商品信息</span>
          <div class="handel-btn">
            <button class="empty cursorPointer" @click="delCart()">
              全部清空
            </button>
            <button class="order cursorPointer" @click="toOverBook()">
              去下单
            </button>
            <!-- <button class="order cursorPointer" @click="bindReagent('1')">
              绑定柜机
            </button> -->
          </div>
        </div>
        <el-table
          :data="cartList"
          @selection-change="handleSelectionChange"
          :row-class-name="tableRowClassName"
          ref="multipleTable"
          :header-cell-style="{
            background: '#F8FAFC',
            color: 'rgba(0, 0, 0, 0.85)',
            fontWeight: 600,
          }"
          border
          style="width: 100%"
        >
          <el-table-column
              type="selection">
          </el-table-column>
          <el-table-column label="商品名称" max-width="8%">
            <template slot-scope="scope">
              <span>
                            <el-popover
                                placement="top-start"
                                width="200"
                                trigger="hover"
                                :content="scope.row.goodsName">
                <p type="text" slot="reference">{{ scope.row.goodsName }}<span v-show="1 == scope.row.isStock" style="margin-left: 5px"><el-tag size="mini" type="danger" effect="dark">期货</el-tag></span></p>
              </el-popover>
              </span>

            </template>
          </el-table-column>
          <el-table-column prop="casNo" label="CAS号">
            <template slot-scope="scope">
              <span style="line-height: 40px">{{scope.row.casNo}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="brand" label="品牌"/>
          <el-table-column prop="supplierName" label="供应商"/>
          <el-table-column prop="goodsNo" label="商品编码" :show-overflow-tooltip="true"> </el-table-column>
          <el-table-column prop="specNames" label="规格" max-width="12%" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{scope.row.specNames}}{{scope.row.specNames && scope.row.specExtension ? ', ' : ''}}{{scope.row.specExtension}}</span>
            </template>
          </el-table-column>
          <el-table-column label="剂量（单位）">
            <template slot-scope="scope">
              <span v-if="scope.row.productType == 0">{{ scope.row.weight }}</span>
              <span v-if="scope.row.productType == 1">{{ scope.row.packageType }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="salesPrice" label="单价">
            <template v-slot="scope">
              <span>{{scope.row.salesPrice}}元</span>
            </template>
          </el-table-column>
          <el-table-column prop="num" label="购买量" max-width="9%">
            <template slot-scope="scope">
              <!-- :max="scope.row.weight" -->
              <el-input-number
                v-model="scope.row.num"
                :disabled="scope.row.isExpire"
                :min="1"
                @change="changeNum(scope.row)"
                size="small"
                label="描述文字"
              ></el-input-number>
            </template>
          </el-table-column>
<!--          <el-table-column prop="specExtension" label="备注" max-width="12%">-->
<!--            <template slot-scope="scope" >-->
<!--              <div class="" style="display: flex;align-items: center;" v-show="scope.row.productType == 1">-->
<!--                <el-input v-model="scope.row.specExtension" type="textarea" size="medium" @change="changeSpecExtension(scope.row)" autosize></el-input>-->
<!--              </div>-->
<!--            </template>-->
<!--          </el-table-column>-->

          <el-table-column prop="salesPrice" label="总价">
            <template v-slot="scope">
              <span>{{(scope.row.salesPrice*scope.row.num).toFixed(2)}}元</span>
            </template>
          </el-table-column>
          <el-table-column label="绑定柜机">
            <template slot-scope="scope">
              <span class="unBind" v-if="!scope.row.binding">未绑定</span>
              <span v-else>{{ scope.row.gjwz }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button @click="usableCabinet(scope.row)" v-show="!scope.row.isExpire" type="text" size="middle" class="bind-goods">绑定</el-button>
              <el-button type="text" size="middle" @click="delCart(scope.row)" class="del-goods">删除</el-button>
              <el-tooltip class="item" effect="dark" content="商品已失效"
                          style="margin-left: 5px" v-if="scope.row.isExpire" placement="right-start">
                <span><i slot="reference" class="el-icon-warning" style="color: #606266"></i></span>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="census clearfix">
        <span class="amount"
          >总金额：<i>¥ {{ allPrice }}</i></span
        >
        <span class="total"
          >总计：<i>{{ allNum }} 件</i></span
        >
      </div>
      <div>
        <el-collapse accordion style="border: 0;margin-top: 20px;margin-left: 20px" class="custom-collapse1">
          <el-collapse-item class="custom-collapse-item1">
            <template slot="title">
              <span >点击查看采购流程<i class="header-icon el-icon-question"></i></span>
            </template>
            <img src="../../assets/images/buy.png" alt="采购流程">
          </el-collapse-item>
        </el-collapse>
      </div>
      <!-- 绑定柜机弹框 -->
      <el-dialog title="绑定柜机" :visible.sync="dialogBind" class="bindDia" width="800px">
        <div class="searchName" v-show="this.canBindCab.length > 0">
          <input
            type="text"
            v-model="cabName"
            placeholder="查询柜子名称"
            @keyup.enter="getCanUseList"
          />
          <el-button type="primary" @click="getCanUseList">查询</el-button>
        </div>
        <div v-show="this.canBindCab.length == 0" style="text-align:center;margin-top: 20px">
          <el-link :underline="false" type="primary" @click="newCabinet">您还没有柜子哦，去新建 >></el-link>
        </div>
        <div class="all-cabinet">
          <ul>
            <li v-for="(item, index) in canBindCab" :key="index">
              <el-radio
                v-model="cabId"
                :label="item.id"
                :disabled="currentInfo.num > item.sum"
                @change="onRadioChange(item)"
              >
                <div
                  class="text-overflow"
                  @click="onRadioChange(item)"
                  style="width: 290px; margin-right: 10px"
                >
                  {{ item.cabName }}
                </div>
              </el-radio>
              <div class="centerbox" @click="onRadioChange(item)">
                <span
                  class="cabinet-type"
                  v-if="item.cabType == 1"
                  @click="onRadioChange(item)"
                  >智能柜</span
                >
                <span class="cabinet-type2" @click="onRadioChange(item)" v-else
                  >门禁柜</span
                >
                <span
                  v-if="item.cabType == 1"
                  class="remnant"
                  @click="onRadioChange(item)">
                    剩余可存量：
                    <i>{{ item.sumGrid }}</i>
                    <!-- <i>{{ item.sumGrid - item.cabCount}}</i> -->
                  </span>
                <span v-else class="remnant" @click="onRadioChange(item)"
                  >已用托盘/总托盘：<i>{{
                    (item.sumGrid ? item.sumGrid : 0) + "/" + item.cabCount
                  }}</i></span
                >
              </div>

              <span
                class="chooseText"
                v-if="selectPlGj == true"
                @click="onSelectCabinet1(item)"
                >批量绑定</span
              >
            </li>
          </ul>
        </div>

        <div slot="footer" class="dialog-footer" v-show="this.canBindCab.length > 0">
          <el-button @click="dialogBind = false">取 消</el-button>
          <el-button type="primary" @click="bindCabinet()">确 定</el-button>
        </div>
      </el-dialog>


      <!-- 选择门禁柜位置 -->
      <el-dialog
        title="选择托盘/查看已存试剂"
        :visible.sync="dialogSelect"
        width="900px"
        class="selectLocationBox"
      >
        <span style="float: right; margin-bottom: 15px">
          <el-button type="primary" @click="selectPlace"
                >确定选择托盘</el-button
              >
              <el-button type="primary" @click="getCabinetDetail"
                >查看已存试剂</el-button
              >
<!--              <el-button type="primary" @click="openEditNum"-->
<!--                >修改存储数量</el-button-->
<!--              >-->
        </span>
        <el-table
          :data="selectLocationList2"
          @cell-click="handleCellClick"
          :cell-style="handleCellStyle"
          border
          style="width: 100%; height: 100%"
          max-height="500"
        >
          <!--  -->
          <el-table-column type="index" width="70px" :index="indexMethod">
          </el-table-column>

          <el-table-column
            v-for="(item, index) in dataColumn"
            :key="index"
            :label="colIndexArr[index] + '列'"
            min-width="120px"
          >
            <template slot-scope="scope">
              <div
                v-if="scope.row[index].isDel"
                style="text-decoration: line-through; background-color: #d9d9d9"
              >
                {{ scope.row[index].numX }}, {{ scope.row[index].numY }}
                <span>（已存 {{scope.row[index].reagentNum}}）</span>
<!--                （余-->
<!--                <span v-if="scope.row[index].reagentTotalNum != null">{{-->
<!--                  scope.row[index].reagentTotalNum - scope.row[index].reagentNum-->
<!--                }}</span>-->
<!--                <span v-else>0</span>-->
<!--                ）-->
              </div>
              <span v-else>
                {{ scope.row[index].numX }}, {{ scope.row[index].numY }}
                <span>（已存 {{scope.row[index].reagentNum}}）</span>
<!--                （余-->
<!--                <span v-if="scope.row[index].reagentTotalNum != null">{{-->
<!--                  scope.row[index].reagentTotalNum - scope.row[index].reagentNum-->
<!--                }}</span>-->
<!--                <span v-else>0</span>-->
<!--                ）-->
              </span>
            </template>
          </el-table-column>
        </el-table>

        <!-- <div style="margin-top: 10px">
              共计{{ lockerCabinet.numX }} 行{{ lockerCabinet.numY }} 列<span
                style="margin-left: 10px"
                >{{ lockerCabinet.numX * lockerCabinet.numY }}个位置</span
              >
            </div> -->
      </el-dialog>

           <!--    查看试剂弹出框-->
      <el-dialog
            title="查看已存试剂"
            :visible.sync="cabinetDetailVisible"
            width="600px"
          >
            <span style="color: black; font-weight: bold"
              >托盘码：{{ placeCode }}</span
            >
            <span style="margin-left: 100px; color: black; font-weight: bold"
              >已存数量：{{ lockerCabinetGrid.reagentNum }}</span
            >
            <!--            <div style="margin-top: 10px;color: black;font-weight: bold">已存试剂列表</div>-->
            <el-table :data="newReagentList" border style="margin-top: 10px">
              <el-table-column label="试剂编号" prop="id">
                <template v-slot="scope">
                  <span v-if="scope.row.code">{{scope.row.code}}</span>
                  <span v-else>{{scope.row.id}}</span>
                </template>
              </el-table-column>
              <el-table-column label="试剂名称" prop="reagentName">
              </el-table-column>
              <el-table-column label="试剂状态" prop="">
                <template slot-scope="scope">
                  {{ handleStatusConvert(scope.row.operation) }}
                </template>
              </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
              <el-button @click="cabinetDetailVisible = false">取 消</el-button>
              <el-button type="primary" @click="cabinetDetailVisible = false"
                >确 定</el-button
              >
            </span>
          </el-dialog>

          <!-- 修改存储数量 dialog-->
      <el-dialog
            title="修改存储数量"
            :visible.sync="editNumDialog"
            class="placeDia"
            width="600px"
          >
            <el-row style="text-align: center; line-height: 40px">
              <el-col :span="4">
                <span>存储数量</span>
              </el-col>
              <el-col :span="8">
                <el-input v-model="editNum" type="number" :disabled="editInputDisable"/>
              </el-col>
              <el-col :span="8">
                <el-button
                  type="primary"
                  style="padding: 7px 14px"
                  @click="editInputDisable = false"
                  >修改</el-button
                >
                <el-button
                  type="primary"
                  style="padding: 7px 14px"
                  @click="saveEditNum"
                  >保存</el-button
                >
              </el-col>
            </el-row>
          </el-dialog>


    </div>
  </div>
</template>
<script>
import { EventBus } from "../../config/event-bus.js";
export default {
  data() {
    return {
      currentVersion: null,
      orderLoading:false,
      loading:false,
      showData:null,
      showFlag:false,
      multipleSelection:[],
      cartId: "",
      //allNum: 0,
      //allPrice: 0,
      bindCartNum: "",
      canBindCab: [],
      allIds: [],
      cabName: "",
      num: 1,
      cabId: "",
      cabType: 1,

      //改 门禁柜相关
      gridId: "",
      numX: "",
      numY: "",
      dialogBind: false,
      content: "",
      cartList: [],
      howWidth: 12,
      //正在操作商品
      currentInfo: {},
      currentLocationId: "",
      dialogSelect: false,
      locationDataTotal: 0,
      locationTotalpage: 0,
      locationSearchData: {
        pageSize: 10,
        pageNum: 1,
      },
      //选择位置
      selectLocationId: "",
      selectLocationList: [],
      //批量选择柜机标记
      selectPlGj: false,
      reagentNumAll: 1,
      selectLocationList2: [],
      dataColumn: null,
      lockerCabinet: {
        columnList: [],
        rowList: [],
        numX: "",
        numY: "",
      },
      colIndexArr: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "U",
        "V",
        "W",
        "x",
        "Y",
        "Z",
      ],
      row: "",
      column: "",
      rowIndex: "",
      columnIndex: "",
      cabinetDetailVisible: false,
      placeCode: "",
      lockerCabinetGrid: {},
      newReagentList: [],
      editNumDialog: false,
      editInputDisable:true,
      editNum: null,
    };
  },
  created() {
    const currentUser = localStorage.getItem('userInfo')
    //获取当前系统版本
    this.currentVersion = JSON.parse(currentUser).taskSalesVersion;
    this.myCartList();
  },
  computed: {
    allNum() {
      return this.cartList.reduce((acc, cur) => acc + cur.num, 0);
    },
    allPrice() {
      return this.cartList
        .reduce((acc, cur) => acc + cur.num * cur.salesPrice, 0)
        .toFixed(2);
    },
  },
  methods: {
    tableRowClassName({row, rowIndex}) {
      if(row.isExpire == true){
        return 'expire-row'
      }
      return '';
    },
    showReagentInfo(casNo){
      this.loading = true
      this.showData = null
      this.$apiFetch
          .get(`/lockerCas/searchCas`, {
            content:casNo
          })
          .then((res) => {
            this.showData = res.data
            if(res.data){
              if(res.data.hazardStatements){
                let HazardStatementsParseValue = res.data.hazardStatements?JSON.parse(res.data.hazardStatements):["-"]
                this.showData.hazardStatements = HazardStatementsParseValue;
              }
            }

            this.loading = false
          })
          .catch(err=>{
            this.loading = false
          })
    },

    setMultipleSelectionData(rows){
      this.multipleSelection = []
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row,true);
        });
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 状态转换
    handleStatusConvert(status) {
      if (status == 8) {
        return (status = "订购中");
      } else if (status == 1) {
        return (status = "待入库");
      } else if (status == 2) {
        return (status = "在库");
      } else if (status == 3) {
        return (status = "已借出");
      } else if (status == 4) {
        return (status = "已取出");
      } else if (status == 5) {
        return (status = "移除中");
      } else if (status == 6) {
        return (status = "移除成功");
      } else if (status == 7) {
        return (status = "转借申请中");
      }  else if (status == 88) {
        return (status = "购物车中");
      } else if (status == 9) {
        return (status = "盘点中");
      } else if (status == 10) {
        return (status = "盘点遗失");
      } else {
        return (status = "-");
      }
    },

    //打开编辑 数量
    openEditNum(){
      if(!(this.row!=undefined && this.column!=undefined && this.row!="" && this.column!="")) {
        this.$message.error("请先选择位置")
        return ;
      } 
      
      this.$apiFetch
        .post(`/cabinetGrid/getLockerCabinetGrid/`, {
          cabId: this.lockerCabinet.id,
          numX: this.rowIndex,
          numY: this.columnIndex,
        })
        .then((res) => {
          if(res.data.del){
            this.$message.error("该位置已被禁用，不能修改数量~")
            return ;
          }
          this.lockerCabinetGrid = res.data;
          this.editNum = res.data.reagentTotalNum
          this.editNumDialog = true;
        });
    },

    // 修改数量 保存按钮
    saveEditNum() {
      this.placeCode =
        this.lockerCabinet.cabName +
        "（" +
        this.rowIndex +
        "," +
        this.columnIndex +
        "）";
      this.$apiFetch
        .post(`/cabinetGrid/getLockerCabinetGrid/`, {
          cabId: this.lockerCabinet.id,
          numX: this.rowIndex,
          numY: this.columnIndex,
        })
        .then((res) => {
          this.lockerCabinetGrid = res.data;
          let ids = [];
          ids.push(res.data.id);
          this.$apiFetch
            .post(`/cabinetGrid/editGridNumByIds/${this.editNum}`, ids)
            .then((res) => {
              if (res.status == 200) {
                this.$message.success("修改成功");
                this.getCurrentLocation();
                this.getCurrentLocationInit()
              } else {
                this.$message.success("修改失败");
              }
            });
          this.editNumDialog = false;
          this.editNum = "";
          this.editInputDisable = true;
        });
    },

    // 单元格 样式及单击
    handleCellStyle(row, rowIndex, column) {
      if (this.row === row.row && this.column === row.column) {
        this.rowIndex = row.rowIndex + 1;
        this.columnIndex = row.columnIndex;
        return "background-color:#00b050;";
      } else {
        return "background-color:#fff;cursor:pointer;";
      }
    },

    handleCellClick(row, column, cell, event) {
      this.row = row; // 取个唯一值用作判定行
      this.column = column;
    },

    // 查看已存试剂详情
    getCabinetDetail() {
      if(!(this.row!=undefined && this.column!=undefined && this.row!="" && this.column!="")) {
        this.$message.error("请先选择位置")
        return ;
      } 
      this.placeCode =
        this.lockerCabinet.cabName +
        "（" +
        this.rowIndex +
        "," +
        this.columnIndex +
        "）";
      
      this.$apiFetch
        .post(`/cabinetGrid/getLockerCabinetGrid/`, {
          cabId: this.lockerCabinet.id,
          numX: this.rowIndex,
          numY: this.columnIndex,
        })
        .then((res) => {
          this.lockerCabinetGrid = res.data;
          this.placeCode =this.lockerCabinet.cabName +"(" +this.lockerCabinetGrid.numX +"," + this.lockerCabinetGrid.numY +")";
          this.$apiFetch
            .get(`/cabinetGrid/queryReagentByGrid/${res.data.id}`)
            .then((res) => {
              if (res.status == 200) {
                if(res.data.code){
                  this.$message.error(res.data.description);
                  return ;
                }
                this.cabinetDetailVisible = true;
                this.newReagentList = res.data;
              }
            });
        });
    },

    // 选择位置
    selectPlace() {
      if(!(this.row!=undefined && this.column!=undefined && this.row!="" && this.column!="")) {
        this.$message.error("请先选择位置")
        return ;
      } 

      this.$apiFetch
        .post(`/cabinetGrid/getLockerCabinetGrid/`, {
          cabId: this.lockerCabinet.id,
          numX: this.rowIndex,
          numY: this.columnIndex,
        })
        .then((res) => {
          this.gridId = res.data.id 
          console.log(" 确定选择位置后，",this.gridId)

          if (res.data.del) {
            this.$message.error("该位置已被禁用，请重新选择");
            return;
          }
          let remainder = (res.data.reagentTotalNum - res.data.reagentNum)
          // if(remainder<this.reagentNumAll){
          //   this.$message.error("该位置放不下了，请重新选择位置")
          //   return ;
          // }else{
            this.cabId = this.currentLocationId;
            this.numX = this.rowIndex;
            this.numY = this.colIndexArr[this.columnIndex - 1];
            this.dialogSelect = false;
            this.bindCabinet()
          // }
          
        });


        
     
    },

    //    // 表头行
    indexMethod(index) {
      return "第" + (index + 1) + "行";
    },
    // 数据处理
    getNewData(data) {
      this.selectLocationList2 = [];
      for (let i = 1; i <= this.lockerCabinet.numX; i++) {
        this.selectLocationList2.push(data[`${i}`]);
      }
      console.log("new Data", this.selectLocationList2);
      this.dataColumn = this.selectLocationList2[0];
    },

    // 获取当前门禁中位置2
    async getCurrentLocationInit() {
      const id = this.currentLocationId;
      const { data } = await this.$apiFetch.get(
        "/cabinetGrid/queryCabinetGridList2",
        { id }
      );
      if (!data.code) {
        this.getNewData(data);
      }
    },

    // end

    //购物车列表
    myCartList() {
      this.$apiFetch.get("/lockerShopCart/list").then((res) => {
        this.cartList = res.data;
        this.$nextTick(()=>{
          this.setMultipleSelectionData(this.cartList)
        })
        this.allIds = this.cartList.map((item) => item.id);
        console.log(this.allIds);
        // res.data.map((item) => {
        //   this.allIds.push(item.id)
        //   //this.allNum += item.num
        //   // this.allPrice += item.salesPrice
        // })
      });

      this.$apiFetch.get(`/lockerShopCart/myCartNum`).then((res) => {
        EventBus.$emit('showCityName', res.data);
        localStorage.setItem("test", res.data)
      });
    },
    //批量绑定柜机
    bindReagent() {
      this.selectPlGj = true;
      this.dialogBind = true;
      this.$apiFetch.get(`/lockerCabinet/queryAvailableCabList`).then((res) => {
        console.log(res);
        this.canBindCab = res.data;
        this.canBindCab.forEach((item) => {
          this.$set(item, "bindCartNum", 1);
        });
      });
    },
    //可用柜机
    usableCabinet(row) {
      this.selectPlGj = false;
      this.dialogBind = true;
      this.cartId = row.id;
      this.currentInfo = row;


      this.reagentNumAll = row.num

      // let cabName = this.cabName
      this.$apiFetch.get(`/lockerCabinet/queryAvailableCabList`).then((res) => {
        console.log(res);
        
        if (row.cabId) {
          this.cabId = row.cabId;
        } else {
          this.cabId = "";
        }
        this.canBindCab = res.data;
        this.canBindCab.forEach((item) => {
          this.$set(item, "bindCartNum", 1);
        });
      });
    },
    getCanUseList() {
      this.$apiFetch
        .get(`/lockerCabinet/queryAvailableCabList`, { cabName: this.cabName })
        .then((res) => {
          console.log(res);
          this.canBindCab = res.data;
          this.canBindCab.forEach((item) => {
            this.$set(item, "bindCartNum", 1);
          });
        });
    },
    //绑定柜机
    bindCabinet() {
      // if (this.selectPlGj) {
        this.dialogBind = false;
      // }
      const cur = this.canBindCab.find((item) => item.id == this.cabId);
      const num = this.reagentNumAll;
      const sum = cur.sum;
      // let num = this.bindCartNum
      let cartId = this.cartId;
      let id = this.cabId;
      if (id == "") {
        this.$message.error("请选择绑定柜机");
        return;
      }
      // if (num !== this.currentInfo.num) {
      //   this.$message.error("绑定量必须和购买量相等");
      //   return;
      // }

      if (num > sum) {
        this.$message.error("绑定量不能超过柜机剩余可存量");
        return;
      }

      // if (this.cabType === 2) {
      //   if (!this.gridId) {
      //     this.$message.error("请选择门禁柜绑定位置");
      //     return;
      //   }
      // }

      let params = { num, id, cartId };
      if (this.cabType === 2) {
        params.gridId = this.gridId;
      }

      // `/lockerShopCart/bindingCabinet?num=${num}&cabId=${id}&cartId=${cartId}`

      console.log("xixihaha",this.gridId,params.gridId)
      this.$apiFetch
        .post("/lockerShopCart/bindingCabinet", params)
        .then((res) => {
          if (res.data.code == 418) {
            this.$message.error(res.data.description);
          } else {
            this.$message.success("绑定成功");
            this.dialogBind = false;
            this.myCartList();
          }
        });
    },
    //删除购物车
    delCart(row) {
      let ids = [];
      if (row) {
        ids.push(row.id);
      } else {
        ids = this.allIds;
      }
      let params = {
        ids,
      };
      this.$apiFetch.post("/lockerShopCart/delete", params).then((res) => {
        console.log(res);
        this.$message.success("删除成功");
        this.myCartList();
      });
    },

    //去下单
    toOverBook() {
      this.orderLoading = true;
      // if (this.cartList.length == 0) {
      if (this.multipleSelection.length == 0) {
        this.$message.error("请选择商品后下单");
        this.orderLoading = false;
        return;
      }
      let ids = []
      this.multipleSelection.forEach((item)=>{
        ids.push(item.id)
      })
      this.$apiFetch.post("/lockerOrders/calculateOrderByIds",ids).then((res) => {
        this.orderLoading = false;
        console.log(res);
        if (res.data.code == 418 || res.data.code == 419) {
          this.$message.error(res.data.description);
          this.myCartList();
        } else {
          this.$router.push({ path: "overBook" });
        }

        this.$apiFetch.get(`/lockerShopCart/myCartNum`).then((res) => {
          EventBus.$emit("showCityName", res.data);
          localStorage.setItem("test", res.data);
        });
      }).catch((err)=>{
        this.orderLoading = false;
      });
    },
    //修改购物车数量
    async changeNum(info) {
      const { goodsId, goodsSkuDetailId, num, weightUnit, supplierId, casNo ,specIds, productType} =
        info;
      const gjwz = "del";
      this.$apiFetch
        .post("/lockerShopCart", {
          goodsId,
          goodsSkuDetailId,
          num,
          weightUnit,
          gjwz,
          supplierId,
          casNo,
          specIds,
          productType
        })
        .then((res) => {
          console.log(res);
          if (res.data.code) {
            this.myCartList();
          }
        });
    },
    async changeSpecExtension(row){
      const data = {};
      data.id = row.id;
      data.specExtension = row.specExtension;
      this.$apiFetch
          .post("/lockerShopCart/modify", data).then((res) => {
            console.log(res);
            if (res.data.code) {
              this.myCartList();
            }
          });
    },
    //解绑柜机
    unUsableCabinet(info) {
      console.log(info);
    },
    //选择柜机 查看位置列表
    async onSelectCabinet(data1) {
      this.currentLocationId = data1.id;
      this.cabType = 2;
      if (!this.selectPlGj) {
        this.dialogSelect = true;
        this.getCurrentLocation();
        this.getCurrentLocationInit();
      } else {
        let that = this;
        const { data } = await this.$apiFetch.get(
          `/cabinetGrid/queryCabinetGridListAll`,
          { id: this.currentLocationId }
        );
        console.log(data);
        const cartListData = that.cartList;
        let resultData = data;
        let openNum = 0;
        cartListData.forEach(function (item, i) {
          if (cartListData.length <= resultData.length) {
            let gridIds = resultData[i].id;
            let numXs = resultData[i].numX;
            let numYs = resultData[i].numY;
            let reagentNum = resultData[i].reagentNum;

            console.log(gridIds + numXs + numYs + reagentNum);
            const num = item.num;
            // let num = this.bindCartNum
            let cartId = item.id;
            let id = resultData[i].cabId;
            if (id == "") {
              this.$message.error("请选择绑定柜机");
              return;
            }
            let params = { num, id, cartId };
            if (that.cabType === 2) {
              params.gridId = resultData[i].id;
            }
            // that.$apiFetch
            //   .post("/lockerShopCart/bindingCabinet", params)
            //   .then(async (rsultData1) => {
            //     openNum++;
            //     if (rsultData1.data.code == 418) {
            //       that.$message.error(rsultData1.data.description);
            //     }
            //     that.myCartList();
            //     if (openNum == cartListData.length) {
            //       that.$message.success("绑定成功");
            //       that.dialogBind = false;
            //     }
            //   });
          } else {
            that.$message.error("柜机数小于商品数，无法存放！");
            return;
          }
        });
      }
    },
    //选择柜机 查看位置列表
    async onSelectCabinet1(data1) {
      debugger;
      this.currentLocationId = data1.id;
      this.cabType = 2;
      if (!this.selectPlGj) {
        this.dialogSelect = true;
        this.getCurrentLocation();
        // this.getCurrentLocationInit(this.currentLocationId);
      } else {
        let that = this;
        const { data } = await this.$apiFetch.get(
          `/cabinetGrid/queryCabinetGridListAll`,
          { id: this.currentLocationId }
        );
        console.log(data);
        const cartListData = that.cartList;
        let resultData = data;
        let openNum = 0;
        cartListData.forEach(function (item, i) {
          if (cartListData.length <= resultData.length) {
            let gridIds = resultData[i].id;
            let numXs = resultData[i].numX;
            let numYs = resultData[i].numY;
            let reagentNum = resultData[i].reagentNum;

            console.log(gridIds + numXs + numYs + reagentNum);
            const num = item.num;
            // let num = this.bindCartNum
            let cartId = item.id;
            let id = resultData[i].cabId;
            if (id == "") {
              this.$message.error("请选择绑定柜机");
              return;
            }
            let params = { num, id, cartId };
            if (that.cabType === 2) {
              params.gridId = resultData[i].id;
            }
            that.dialogSelect = false;
            // that.$apiFetch
            //   .post("/lockerShopCart/bindingCabinet", params)
            //   .then(async (rsultData1) => {
            //     openNum++;
            //     if (rsultData1.data.code == 418) {
            //       that.$message.error(rsultData1.data.description);
            //     }
            //     that.dialogSelect = false;
            //     that.myCartList();
            //     if (openNum == cartListData.length) {
            //       that.$message.success("绑定成功");
            //       that.dialogBind = false;
            //     }
              // });
          } else {
            that.$message.error("柜机数小于商品数，无法存放！");
            return;
          }
        });
      }
    },
    //获取当前门禁中位置
    async getCurrentLocation() {
      const { currentLocationId } = this;
      const { data } = await this.$apiFetch.get("/lockerCabinet/getCabinet", {
        id: currentLocationId,
      });
      this.lockerCabinet = data;
    },
    onSelectLocation(data) {
      debugger;
      this.cabId = this.currentLocationId;
      this.gridId = data.id;
      this.numX = data.numX;
      this.numY = data.numY;
      this.reagentNumAll = data.reagentNumAll;
      this.$message.success("选择成功！");
      this.dialogSelect = false;
    },
    locationChangePage(data) {
      this.locationSearchData.pageNum = data;
      this.getCurrentLocation();
    },
    onRadioChange(item) {
      console.log(item);
      if (item.cabType == 2) {
        // this.currentLocationId = item.id;
        // this.dialogSelect = true;
        // this.getCurrentLocation();
        this.onSelectCabinet(item);
      }
    },
    newCabinet(){
      if(this.currentVersion > 10){
        this.$router.push({ name: "cabinetRun", params: { type: 'orderAdd' } });
      }else {
        this.$router.push({ name: "cabinetRun10", params: { type: 'orderAdd' } });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.reagentTextOverflow{
  word-break: break-all;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.main {
  background-color: #ffffff;
}
.goods-info {
  padding: 20px;
  margin-top: 20px;
  background-color: #ffffff;
  .table-title {
    position: relative;
    color: #333333;
    font-size: 16px;
    line-height: 22px;
    font-weight: 700;
    position: relative;
    padding-left: 11px;
    padding-bottom: 12px;
    border-bottom: 1px solid #eef2f8;
    .handel-btn {
      position: absolute;
      right: 0;
      bottom: 9px;
      button {
        width: 98px;
        height: 36px;
        border-radius: 4px;
        font-size: 12px;
      }
      .empty {
        background-color: #ffffff;
        color: #666666;
        border: 1px solid #999999;
      }
      .order {
        background-color: #478aff;
        color: #ffffff;
        margin-left: 12px;
      }
    }
  }
  .table-title::before {
    width: 3px;
    height: 16px;
    background: #478aff;
    content: "";
    position: absolute;
    left: -6px;
    top: 3px;
  }
  .el-table .cell {
    img {
      display: block;
      width: 80px;
    }
    .unBind {
      color: #fa8c16;
    }
  }
  /deep/ .el-input-number--small {
    width: 110px;
  }
  /deep/ .el-input-number__decrease {
    background-color: #ffffff;
  }
  /deep/ .el-input-number__increase {
    background-color: #ffffff;
  }
  .bind-goods {
    width: 50%;
    text-align: left;
  }
  .del-goods {
    color: #ff4d4f;
  }
}
.bindDia {
  p {
    padding-top: 25px;
    font-size: 14px;
    color: #666666;
    line-height: 20px;
  }
  ul {
    li {
      display: flex;
      align-items: center;
      background-color: #fafafa;
      border-radius: 4px;
      height: 48px;
      margin-top: 8px;
      padding: 0 12px;

      /deep/ .el-radio__input.is-checked + .el-radio__label {
        color: #333333;
        font-size: 14px;
      }
      /deep/ .el-radio {
        margin-right: 8px;
      }
      /deep/ .el-radio__label {
        color: #333333;
        font-size: 14px;
      }

      .centerbox {
        width: 240px;
        display: flex;
        align-items: center;
      }

      .cabinet-type {
        display: block;
        width: 48px;
        height: 20px;
        line-height: 20px;
        background: #eaf1fc;
        border-radius: 4px;
        color: #478aff;
        font-size: 12px;
        text-align: center;
        margin-right: auto;
      }
      .cabinet-type2 {
        display: block;
        width: 48px;
        height: 20px;
        line-height: 20px;
        background: rgba(250, 140, 22, 0.08);
        border-radius: 4px;
        color: #fa8c16;
        font-size: 12px;
        text-align: center;
        margin-right: auto;
      }

      .remnant {
        padding-right: 10px;
        i {
          color: #081020;
        }
      }

      .chooseText {
        margin-left: 5px;
        font-size: 14px;
        color: #478aff;
        line-height: 20px;
        cursor: pointer;
      }

      /deep/.el-input-number__decrease {
        border-right: 1px solid #e9e9e9;
        background-color: #fafafa;
        .el-icon-minus {
          color: #979797;
          font-weight: 700;
        }
      }
      /deep/ .el-input-number__increase {
        border-left: 1px solid #e9e9e9;
        background-color: #fafafa;
      }
      /deep/.el-input__inner {
        border: 1px solid #e9e9e9;
        color: #333333;
        font-weight: 700;
      }
    }
  }
}
.searchName {
  input {
    width: 434px;
    height: 36px;
    border-radius: 4px;
    border: 1px solid #cccccc;
    box-sizing: border-box;
    padding-left: 9px;
  }
  button {
    width: 98px;
    height: 36px;
    margin-left: 12px;
    vertical-align: bottom;
  }
}
.census {
  padding-right: 20px;
  span {
    color: #333333;
    font-size: 13px;
    float: right;

    i {
      font-weight: 600;
      font-size: 15px;
    }
  }
  span.total {
    padding-right: 32px;
  }
}
.text-overflow {
  display: -webkit-box;
  text-overflow: ellipsis;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; //当属性值为3，表示超出3行隐藏
}

.selectLocationBox {
  .el-table {
    border: 1px solid #e8e8e8;

    .el-table thead {
      background-color: #f8fafc;
      color: rgba(0, 0, 0, 0.85);
    }

    .selectText {
      height: 21px;
      font-size: 14px;
      color: #478aff;
      line-height: 21px;
      cursor: pointer;
    }
  }
}

/deep/.el-radio__input.is-disabled.is-checked .el-radio__inner::after {
  width: 10px;
  height: 10px;
  background-color: #478aff;
}

/deep/.el-radio__input.is-disabled.is-checked .el-radio__inner {
  background: unset;
  border-color: #409eff;
}

/deep/.all-cabinet {
  .el-radio {
    display: flex;
    align-items: center;
  }

  .el-radio__input {
    display: flex;
    align-items: center;
  }

  .el-radio__label {
    display: flex;
    align-items: center;
  }
}
.tabelBl{
  border-left: 1px solid #E8E8E8;
}

.tabelBTr{
  border-top: 1px solid #E8E8E8;
  border-right: 1px solid #E8E8E8;
}

.tableLeftTextBox{
  height: 100%;
  min-height: 55px;
  padding-left: 20px;
  color: #666;
  font-size: 14px;
  display: flex;
  align-items: center;

}

.tableRightTextBox{
  min-height: 55px;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #333;
  font-weight: 700;
  padding: 0 20px;
}
.tableImagesBox{
  min-height: 55px;
  display: flex;
  align-items: center;
  padding: 0 20px;
}
.tableBB{
  border-bottom: 1px solid #E8E8E8;
}
.safeBtn {
  display: inline-block;
  padding: 4px 4px;
  border-radius: 50%; /* 椭圆形 */
  background-color: #007bff; /* 背景颜色 */
  color: #fff; /* 文字颜色 */
  text-align: center;
  text-decoration: none;
  font-size: 14px;
}
.wx_btn{
  color: #443e31;
  padding: 2px 4px;
  border-radius: 50%; /* 椭圆形 */
  background-color: #f4b824; /* 背景颜色 */
  text-align: center;
  text-decoration: none;
  font-size: 12px;
}
</style>
<style>
.el-table .expire-row{
  color: #e3e0e0;
  /*background: #dee7d9;*/
}
</style>

